import { render, staticRenderFns } from "./SeminarEvaluation.vue?vue&type=template&id=31c2228c"
import script from "./SeminarEvaluation.vue?vue&type=script&lang=js"
export * from "./SeminarEvaluation.vue?vue&type=script&lang=js"
import style0 from "./SeminarEvaluation.vue?vue&type=style&index=0&id=31c2228c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports